<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div class="chart-wrapper">
    <PrimeChart
      class="chart-full-width"
      :type="type"
      :data="data"
      :options="mergedOptions"
    />
  </div>
</template>

<script>
import Chart from "primevue/chart";

export default {
  name: "ChartWrapper",
  components: {
    PrimeChart: Chart,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    textColor() {
      return getComputedStyle(document.documentElement)
        .getPropertyValue("--p-text-color")
        .trim();
    },
    mergedOptions() {
      return {
        ...this.options,
        plugins: {
          ...this.options?.plugins,
          legend: {
            ...this.options?.plugins?.legend,
            labels: {
              ...this.options?.plugins?.legend?.labels,
              color: this.textColor,
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-wrapper {
  display: flex;
  justify-content: center;
}

.chart-full-width {
  width: 100%;
}
</style>
